import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import NumberField from '../utils/NumberField';
import { Field, Form } from 'react-final-form'
import { verifyNumber } from '../../actions'
import { connect } from 'react-redux'

const SignUpPageOne = (props) => {
    const [, setFormError] = useState(false)
    const { setSignUpHeader } = props
    const FieldErrorRef = useRef(false);
    const FieldErrorMssg = useRef(null)
    const validateForm = (formValues) => {

    }
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setSignUpHeader({'title': 'Verify number', subtitle: 'Please enter your number to receive a 6 digit verification Code.'})

        return () => {
            setSignUpHeader({'title': '', subtitle: ''})
        }
    }, [setSignUpHeader])
    const validateNumber = (value) => {
        if (value){
            if (value[0].match(/[0-6a-zA-Z+]/)){
                FieldErrorRef.current = true
                FieldErrorMssg.current = `Number cannot start with ${value[0]}`
            }
        }
        else{
            FieldErrorRef.current = false
            return undefined
        }
    }
    const submitForm = (formValues) => {
        if (!formValues.number || formValues.number.length !== 10){
            FieldErrorRef.current = true
            FieldErrorMssg.current = "Please Enter a valid 10 Digit number excluding (+91)"
        }
        else{
            setLoading(true)
            props.verifyNumber(formValues, props.signUpSettings, FieldErrorRef, FieldErrorMssg, setFormError, setLoading)
        }
    }
    return(
        <>
            <Form validate={validateForm} onSubmit={submitForm}>
                
                {(formProps) => (
                    <form onSubmit={formProps.handleSubmit} className="login-form ui large form">
                        <Field name='number' validate={validateNumber}>
                            {({ input, meta }) => (
                                
                                <NumberField input={input} label="Mobile Number" meta={meta}/>
                               
                            )}
                            
                        </Field>
                        <div style={{textAlign: 'right'}}>
                            <Link className="ui secondary button" to="/login" onClick={() => props.closeSignup()}>
                                Login
                            </Link>
                            <button className={`ui positive right labeled icon button ${loading && "loading"}`} type="submit">
                                Get Otp
                                <i className="checkmark icon"></i>
                            </button>
                        </div>
                        <div className={`ui message red ${FieldErrorRef.current ? "visible" : "hidden"}`}>
                            <p>{FieldErrorMssg.current}</p>
                        </div>
                    </form>
                )}
            </Form>
        </>
    )
}

export default connect(null, { verifyNumber })(SignUpPageOne);